<template>
  <div
    class="absolute z-[5] flex -translate-x-2/4 -translate-y-2/4 items-center justify-center opacity-10"
    :class="[
      topClass,
      leftClass,
      widthClass,
      { 'remove-me': removeFromChartDownload },
    ]"
  >
    <BenchmarkLogoBlack class="h-28 w-full" />
  </div>
</template>

<script setup lang="ts">
import BenchmarkLogoBlack from '~/assets/icons/BenchmarkLogoBlack.svg'

withDefaults(
  defineProps<{
    topClass?: string
    leftClass?: string
    widthClass?: string
    removeFromChartDownload?: boolean
  }>(),
  {
    topClass: 'top-1/2',
    leftClass: 'left-1/2',
    widthClass: 'w-[95%] mx-auto',
    removeFromChartDownload: true,
  },
)
</script>
